import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { SupportChat } from "./SupportChat";
import { NeoAvatar } from "./NeoAvatar";

/** Bulle flottante « Néo » (landing, blog, présentation). Créer un ticket → /contact pré-rempli via location.state. */
export function SupportChatBubble() {
  const [open, setOpen] = useState(false);
  const [nudge, setNudge] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    if (sessionStorage.getItem("cn_copilot_nudged")) return;
    const t = setTimeout(() => { setNudge(true); sessionStorage.setItem("cn_copilot_nudged", "1"); }, 12000);
    return () => clearTimeout(t);
  }, []);
  const ticket = ({ subject, message }) => { setOpen(false); navigate("/contact", { state: { subject, message } }); };
  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3" data-testid="copilot-bubble">
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 16, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 16, scale: 0.98 }} transition={{ duration: 0.2 }}
            className="w-[min(420px,calc(100vw-2.5rem))] shadow-2xl shadow-black/40 rounded-2xl bg-[#071e42] typo-a" data-testid="copilot-panel">
            <SupportChat onCreateTicket={ticket} page={pathname} />
          </motion.div>
        )}
        {!open && nudge && (
          <motion.button type="button" initial={{ opacity: 0, x: 12 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0 }} onClick={() => { setOpen(true); setNudge(false); }}
            className="max-w-[260px] rounded-2xl bg-white text-[#071e42] text-sm px-4 py-3 shadow-xl text-left" data-testid="copilot-nudge">
            Une question sur Casanéo ? Néo, votre assistant IA, vous répond en quelques secondes.
          </motion.button>
        )}
      </AnimatePresence>
      <button type="button" onClick={() => { setOpen((o) => !o); setNudge(false); }} aria-label={open ? "Fermer Néo" : "Ouvrir Néo, votre assistant IA"}
        className={`h-14 w-14 rounded-full shadow-xl shadow-black/40 grid place-items-center hover:scale-105 transition-transform overflow-hidden ${open ? "bg-brass text-[#071e42]" : "bg-[#f6efe0] ring-2 ring-brass/70"}`} data-testid="copilot-toggle">
        {open ? <X className="h-6 w-6" /> : <NeoAvatar size={56} />}
      </button>
    </div>
  );
}
